//@ts-check
import React from 'react';
import api, { Map, Marker } from '../components/GoogleMaps';
import Loader from '../controls/Loader';
import Center from '../controls/Center';
import Typography from '@material-ui/core/Typography';
import LookupButton from '../components/LookupButton';
/**
 * @param {{children?:any, error?: any}} param
 */

var GoogleMapFrame = function GoogleMapFrame(_ref) {
  var children = _ref.children,
      error = _ref.error;
  var content = error ? React.createElement(Center, null, React.createElement(Typography, {
    variant: "body",
    color: "error"
  }, error)) : children;
  return React.createElement("div", {
    style: {
      height: 400,
      position: 'relative',
      border: '1px solid lightgray'
    }
  }, content);
};
/**
 * @param {import('./types').GoogleMapInputProps} props
 */


var GoogleMap = function GoogleMap(_ref2) {
  var apiKey = _ref2.apiKey,
      address = _ref2.address,
      mapType = _ref2.mapType,
      onChange = _ref2.onChange,
      fieldId = _ref2.fieldId,
      lookupVisiblity = _ref2.lookupVisiblity,
      xpath = _ref2.xpath;
  var googleAPI = api.useGoogleAPI(apiKey);

  var onMapClicked = function onMapClicked(mapProps, map, clickEven) {
    if (!clickEven || !onChange) return;
    onChange({
      lat: clickEven.latLng.lat(),
      lng: clickEven.latLng.lng()
    });
  };

  if (googleAPI.loading) {
    return React.createElement(GoogleMapFrame, null, React.createElement(Loader, null, "Loading Google API"));
  }

  if (!apiKey) {
    return React.createElement(GoogleMapFrame, {
      error: "Map cannot be displayed because API key is missing. Please contact your administrator."
    });
  }

  var isInvalidAddress = !address || !address.lat || !address.lng;

  if (isInvalidAddress) {
    return React.createElement(GoogleMapFrame, {
      error: "Your address appears to be invalid and cannot be displayed on map."
    });
  }

  var showLookupButton = xpath && lookupVisiblity !== 'hide';
  var lookupButton = showLookupButton ? React.createElement(LookupButton, {
    fieldId: fieldId,
    isForMap: true
  }) : React.createElement(React.Fragment, null);
  return React.createElement(GoogleMapFrame, null, React.createElement(Map, {
    mapType: mapType,
    google: googleAPI.google,
    zoom: 10,
    initialCenter: address,
    center: address,
    onClick: onMapClicked
  }, React.createElement(Marker, {
    position: address
  })), lookupButton);
};

export default React.memo(GoogleMap);